export default __webpack_public_path__ + "static/ac005edd0f1fff8ff30c98ae2179381a.jpg";